import { dateFormatter } from './date';
import { timeFormatter } from './time';

export const dateTimeFormatter = (params) => {
  return `${dateFormatter(params)} ${timeFormatter(params)}`;
};
